import { ChatId } from 'src/app/store/samwin/chats/models/chat-id';

export class CommandACK {
   public constructor(public commandType: string, public chatId: ChatId) {
      // nothing to do
   }
}
